<template>
  <div class="inline-comment-composer">
    <cord-composer
      :location="JSON.stringify(threadLocation)"
      :thread-metadata="JSON.stringify(threadMetaData)"
      :thread-name="threadName"
      size="medium"
      show-close-button="true"
      show-expanded="true"
      @cord-composer:close="$emit('close', $event)"
      @cord-composer:send="$emit('messageSend', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'InlineCommentComposer',

  props: {
    threadLocation: { type: Object, default: () => null },
    threadMetaData: { type: Object, default: () => null },
    threadName: { type: String, default: '' },
  },
};
</script>

<style scoped lang="less">
@import '@/less/cord';

.inline-comment-composer {
  .cord-component-composer {
    width: 590px;
    display: block;
  }

  .cord-common-styles();
}
</style>
